import style from "./InfoBox.css";

import { getCookie, setCookie } from "../../helpers";

import { useState } from "preact/hooks";

const InfoBox = (props) => {
  const [cityVendorPromoDismiss, setCityVendorPromoDismiss] = useState(
    getCookie("cityVendorPromoDismiss") || false,
  );

  if (cityVendorPromoDismiss) return null;
  const { city, category, guessedLocation } = props;
  let displayedLocation = city;

  if (!city) displayedLocation = guessedLocation.loc;

  const dismissCityVendorPromo = () => {
    setCookie("cityVendorPromoDismiss", true, 30);
    setCityVendorPromoDismiss(true);
  };

  return (
    <div class={style.infoBox + " " + props.class}>
      <div style="display: flex; align-items: center">
        <span class={style.infoIcon}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 0C4.486 0 0 4.48606 0 10.0001C0 15.5141 4.486 20 10 20C15.514 20 20 15.5141 20 10.0001C20 4.48606 15.514 0 10 0ZM10 18.1818C5.48848 18.1818 1.81818 14.5115 1.81818 10.0001C1.81818 5.48861 5.48848 1.81818 10 1.81818C14.5115 1.81818 18.1818 5.48861 18.1818 10.0001C18.1818 14.5115 14.5115 18.1818 10 18.1818Z"
              fill="black"
            />
            <path
              d="M10.0009 4.24243C9.3327 4.24243 8.78906 4.78643 8.78906 5.4551C8.78906 6.12316 9.3327 6.66667 10.0009 6.66667C10.6692 6.66667 11.2128 6.12316 11.2128 5.4551C11.2128 4.78643 10.6692 4.24243 10.0009 4.24243Z"
              fill="black"
            />
            <path
              d="M9.99893 8.48486C9.49687 8.48486 9.08984 8.89189 9.08984 9.39395V14.8485C9.08984 15.3506 9.49687 15.7576 9.99893 15.7576C10.501 15.7576 10.908 15.3506 10.908 14.8485V9.39395C10.908 8.89189 10.501 8.48486 9.99893 8.48486Z"
              fill="black"
            />
          </svg>
        </span>

        <span style={{ margin: 0, fontSize: "14px" }}>
          <strong>
            {`In ${displayedLocation} besteht eine hohe Nachfrage nach ${category}.`}
          </strong>
          <p style={{ margin: 0 }}>Buche jetzt bevor der Preis steigt. </p>
        </span>
      </div>
      <div
        onClick={() => dismissCityVendorPromo()}
        class={style.dismissInfo}
      ></div>
    </div>
  );
};

export { InfoBox };
